import { PAGE_NAME } from '../../../../configuration/constants';

export enum Providers {
    BigQuery = 'bigQuery',
    Mixpanel = 'mixpanel',
    Grafana = 'grafana',
}

export { PAGE_NAME };

export enum SOURCES {
    page = 'seller_page',
    modal = 'about_seller_modal',
    stickyHeader = 'sticky_header',
    header = 'header',
    gigsCustomOffer = 'gigs_custom_offer',
}

export enum PLATFORM {
    WEB = 'web',
    MOBILE_WEB = 'mobile_web',
}
